import { EOriginSystemId } from '@if/core/types'
import { Typography } from '@mui/material'
import { CreditApplication } from '@src/types/CreditApplicationSchema'
import { useTranslation } from 'react-i18next'
import AddChangeCoappButton from '../AddCoappButton'
import CancelCreditAppButton from '../CancelCreditAppButton'
import DeleteCoApplicantButton from '../DeleteCoapplicantButton'
import UpdateApplicantButton from '../UpdateApplicantButton'

interface Props {
  creditApp: CreditApplication
}

const PrequalCreditReportNotFound = ({ creditApp }: Props) => {
  const { t } = useTranslation()
  const { applicant, coApplicant, id, financingProgramId, originSystemId } = creditApp

  const applicantMissingReport = !applicant.hasCreditReport
  const coapplicantMissingReport = coApplicant?.hasCreditReport === false

  return (
    <>
      {applicant.hasCreditReport && coapplicantMissingReport && (
        <Typography sx={{ mb: 1 }} variant="body1">
          {originSystemId === EOriginSystemId.MerchantDashboard
            ? t('viewCreditApplication.coapplicantCreditReportNotFound')
            : t('viewCreditApplication.coapplicantCreditReportNotFoundOriginNotMerchDb')}
        </Typography>
      )}

      {applicantMissingReport && (
        <>
          <Typography sx={{ mb: 1 }} variant="body1">
            {originSystemId === EOriginSystemId.MerchantDashboard
              ? t('viewCreditApplication.applicantCreditReportNotFound')
              : t('viewCreditApplication.applicantCreditReportNotFoundOriginNotMerchDb')}
          </Typography>
        </>
      )}
      {originSystemId === EOriginSystemId.MerchantDashboard && (
        <>
          {applicantMissingReport && <UpdateApplicantButton id={id} financingProgramId={financingProgramId} />}

          {applicantMissingReport && (!coApplicant || !coApplicant.hasCreditReport) && (
            <AddChangeCoappButton
              id={id}
              financingProgramId={financingProgramId}
              coapp={coApplicant}
              isHardDecline={creditApp.finalCreditDecision?.isHardDecline}
            />
          )}

          {applicant.hasCreditReport && coapplicantMissingReport && (
            <DeleteCoApplicantButton id={id} financingProgramId={financingProgramId} />
          )}

          <CancelCreditAppButton creditApp={creditApp} />
        </>
      )}
    </>
  )
}

export default PrequalCreditReportNotFound
